import { logger } from "./logger";

export const cloneArray = (arr) => {
  try {
    return JSON.parse(JSON.stringify(arr));
  } catch (e) {
    logger.error(e);
    return arr;
  }
};

export const arrayRangeCustom = (start, stop, step) => {
  const result = [];
  for (let i = start; i <= stop; i += step) {
    result.push(i);
  }
  return result;
};

const levenshteinDistance = (str1, str2) => {
  const lenStr1 = str1.length;
  const lenStr2 = str2.length;

  let dp = new Array(lenStr1 + 1);
  for (let i = 0; i <= lenStr1; i++) {
    dp[i] = new Array(lenStr2 + 1);
    dp[i][0] = i;
  }
  for (let j = 0; j <= lenStr2; j++) {
    dp[0][j] = j;
  }

  for (let i = 1; i <= lenStr1; i++) {
    for (let j = 1; j <= lenStr2; j++) {
      let cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
    }
  }

  return dp[lenStr1][lenStr2];
};

export const fuzzySearchInArray = (arr, attr, query, threshold = 0.6) => {
  if (!arr[0][attr]) {
    throw new Error("No attributes in the objects.");
  }

  const results = arr.map((item) => {
    const distance = levenshteinDistance(item[attr].toLowerCase(), query.toLowerCase());
    const similarity = 1 - distance / Math.max(item[attr].length, query.length);
    return { item, similarity };
  });

  return results.filter((result) => result.similarity >= threshold);
};

export const likeSearchInArray = (arr, attr, query) => {
  if (!arr[0][attr]) {
    throw new Error("No attributes in the objects.");
  }

  const results = arr.filter((item) => new RegExp(query, "i").test(item[attr]));
  return results;
};
